document.querySelectorAll('.mega-menu > summary').forEach((summary) => {
  const details = summary.parentElement;

  summary.addEventListener('click', (event) => {
    if (window.matchMedia('(min-width: 991px)').matches) {
      event.preventDefault();         // stop native toggle
      event.stopImmediatePropagation(); // stop any other handlers
      return false;
    }
  });

  const updateAria = () => {
    summary.setAttribute(
      'aria-expanded',
      details.hasAttribute('open')
    );
  };

  details.addEventListener('mouseenter', () => {
    if (!window.matchMedia('(min-width: 991px)').matches) return;
    details.setAttribute('open', '');
    updateAria();
  });

  details.addEventListener('mouseleave', () => {
    if (!window.matchMedia('(min-width: 991px)').matches) return;
    details.removeAttribute('open');
    updateAria();
  });

  summary.addEventListener('click', () => {
    if (window.matchMedia('(max-width: 990px)').matches) {
      details.hasAttribute('open')
        ? details.removeAttribute('open')
        : details.setAttribute('open', '');
      updateAria();
    }
  });
});
